import apiService from './apiService';

/**
 * Action ledger / UNDO (Double tap W/T #210).
 *
 * Thin client over /api/actions — the REST surface that backs the
 * `action_revoke_request` confirmation card. Clicking [Confirm] on that card is
 * the user's approval, so the card calls `revoke` directly, exactly how the
 * document/label/column delete cards call their own REST routes.
 */
export const actionService = {
    /** Recent UNDOABLE actions (creations only), newest first. */
    async recent({ category, limit, conversationId } = {}) {
        const qs = new URLSearchParams();
        if (category) qs.set('category', category);
        if (limit) qs.set('limit', String(limit));
        if (conversationId) qs.set('conversation_id', conversationId);
        const suffix = qs.toString() ? `?${qs.toString()}` : '';
        return apiService.get(`/api/actions/recent${suffix}`);
    },

    /** Undo one action — remove what it created (a document is trashed, not purged). */
    async revoke(actionId) {
        return apiService.post(`/api/actions/${actionId}/revoke`, {});
    },
};

export default actionService;
